/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */


/*
* -------------------------------------------
*                LOAD DATA
* -------------------------------------------
*/

export const WIDGET_PERSONAL_ACCOUNT_LOAD_DATA = '@@b2b_portal_ui/dashboard/widget/WIDGET_PERSONAL_ACCOUNT_LOAD_DATA';
export const WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_SUCCESSFUL
    = '@@b2b_portal_ui/dashboard/widget/WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_SUCCESSFUL';
export const WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_ERROR
    = '@@b2b_portal_ui/dashboard/widget/WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_ERROR';
